/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetProfileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/profile_messages.pb'
import {GetProfileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/profile_messages.pb'


export const getProfileKgoose = (request:GetProfileRequest, options?: CashRequestOptions) => post<GetProfileRequest, GetProfileResponse>("/2.0/cash/get-profile-kgoose", request, {...options, rejectOnError: true })